import Swiper from 'swiper/bundle';


export default function slides() {

  const mySwiper1 = new Swiper ('.swiper-top-mv', { // eslint-disable-line
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    speed: 2400,
    autoplay: {
      delay: 4800,
    },
    loop: true,
    parallax: true,
    breakpoints: {
      748: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });

}